import type { EvidenceUploadMode } from 'api';

import { useGetEvidenceList } from '../../../evidence';

type UseRepresentativeEvidenceParams = {
  representativeEvidenceIds?: number[];
  uploadMode?: EvidenceUploadMode;
  parentId: number;
};

export const useRepresentativeEvidence = ({
  representativeEvidenceIds,
  uploadMode,
  parentId,
}: UseRepresentativeEvidenceParams) => {
  return useGetEvidenceList({
    enabled: Boolean(representativeEvidenceIds?.length),
    mode: uploadMode,
    options: {
      include_ids: representativeEvidenceIds || [],
    },
    parentId: parentId,
  });
};
